// extracted by mini-css-extract-plugin
export default {"istcontainer":"Ayurveda_istcontainer__5tpY1","featuredhbs":"Ayurveda_featuredhbs__nWx4h","Ashwagandha":"Ayurveda_Ashwagandha__oY8-V"};